<template>
  <div class="print-break-after">
    <!-- 
      Div a scomparsa per mostrare un'immagine utilizzando tutta la finestra popup
    -->
    <div v-if="tabToShow === 'pic'" class="wg-row pic-viewer">
      <picture-viewer
        v-if="!showDrawer"
        :picToShow="picToShow"
      ></picture-viewer>
      <picture-drawer
        v-else
        :picToShow="picToShow"
        :projectId="projectId"
        @addImage="addImage"
        @closeDrawer="closePic"
      ></picture-drawer>
      <img
        v-if="!(!this.project.category || this.project.category != 2)"
        :src="$anm22.icons.getWorldIcon('edit')"
        class="edit-pic"
        @click="showDrawer = true"
      />
      <img
        :src="$anm22.icons.getWorldIcon('deleteBlack')"
        class="close-pic"
        @click="closePic"
      />
    </div>
    <!-- 
      Div principale
    -->
    <div v-show="tabToShow === 'default'" class="wg-row">
      <template v-if="!this.project.category || this.project.category != 2">
        <template v-if="mode != 'prod'">
          <div class="wg-row input-row">
            <div class="wg-col wg-xs-6">
              <div
                style="font-size:17px;"
                class="com-anm22-app-text-m suit-model"
              >
                {{ $anm22.strLang(lang, "Model", "Modello") }}
              </div>
            </div>
            <div class="wg-col wg-xs-6">
              <select
                v-if="mode === 'edit'"
                class="input-elem com-anm22-app-select"
                v-model="sheetData.modelName"
              >
                <option
                  v-for="(model, index) in modelsList"
                  :key="'model-' + index"
                  :value="model.modelName"
                  >{{ model.modelName }}</option
                >
              </select>
              <span class="input-text com-anm22-app-text-m" v-else>{{
                sheetData.modelName
              }}</span>
            </div>
          </div>
          <div class="wg-row input-row" style="height:36px;">
            <div class="wg-col wg-xs-3">
              <div class="com-anm22-app-text-m">
                {{ $anm22.strLang(lang, "Boot", "Stivale") }}
              </div>
            </div>
            <div class="wg-col wg-xs-9">
              <div class="wg-row" style="align-items:center;">
                <input
                  :disabled="mode === 'view'"
                  id="boot-i"
                  type="radio"
                  value="internal"
                  style="display:none;"
                  v-model="formData.boot"
                />
                <label class="label-input-radio" for="boot-i">{{
                  formData.boot === "internal" ? "✔" : ""
                }}</label>
                <div class="com-anm22-app-text-m" style="margin:0 5px;">
                  {{ $anm22.strLang(lang, "Internal", "Interno") }}
                </div>
                <div
                  class="com-anm22-horizontal-div"
                  style="width: 20px;"
                ></div>
                <input
                  :disabled="mode === 'view'"
                  id="boot-e"
                  type="radio"
                  value="external"
                  style="display:none;"
                  v-model="formData.boot"
                />
                <label class="label-input-radio" for="boot-e">{{
                  formData.boot === "external" ? "✔" : ""
                }}</label>
                <div class="com-anm22-app-text-m" style="margin:0 5px;">
                  {{ $anm22.strLang(lang, "External", "Esterno") }}
                </div>
              </div>
            </div>
          </div>
          <div class="wg-row input-row" style="height:36px;">
            <div class="wg-col wg-xs-3">
              <div class="com-anm22-app-text-m">Velcro</div>
            </div>
            <div class="wg-col wg-xs-9">
              <div class="wg-row" style="align-items:center;">
                <input
                  :disabled="mode === 'view'"
                  id="velcro-h"
                  type="radio"
                  value="hook"
                  style="display:none;"
                  v-model="formData.velcro"
                />
                <label class="label-input-radio" for="velcro-h">{{
                  formData.velcro === "hook" ? "✔" : ""
                }}</label>
                <div class="com-anm22-app-text-m" style="margin:0 5px;">
                  {{ $anm22.strLang(lang, "Hook", "Uncino") }}
                </div>
                <div
                  class="com-anm22-horizontal-div"
                  style="width: 20px;"
                ></div>
                <input
                  :disabled="mode === 'view'"
                  id="velcro-b"
                  type="radio"
                  value="buttonhole"
                  style="display:none;"
                  v-model="formData.velcro"
                />
                <label class="label-input-radio" for="velcro-b">{{
                  formData.velcro === "buttonhole" ? "✔" : ""
                }}</label>
                <div class="com-anm22-app-text-m" style="margin:0 5px;">
                  {{ $anm22.strLang(lang, "Buttonhole", "Asola") }}
                </div>
              </div>
            </div>
          </div>
          <div class="wg-row input-row" style="height:36px;">
            <div class="wg-col wg-xs-3">
              <div class="com-anm22-app-text-m">
                {{ $anm22.strLang(lang, "Closure", "Chiusura") }}
              </div>
            </div>
            <div class="wg-col wg-xs-9">
              <div class="wg-row" style="align-items:center;">
                <input
                  :disabled="mode === 'view'"
                  id="closure-n"
                  type="radio"
                  value="normal"
                  style="display:none;"
                  v-model="formData.closure"
                />
                <label class="label-input-radio" for="closure-n">{{
                  formData.closure === "normal" ? "✔" : ""
                }}</label>
                <div class="com-anm22-app-text-m" style="margin:0 5px;">
                  {{ $anm22.strLang(lang, "Normal", "Normale") }}
                </div>
                <div
                  class="com-anm22-horizontal-div"
                  style="width: 20px;"
                ></div>
                <input
                  :disabled="mode === 'view'"
                  id="closure-w"
                  type="radio"
                  value="worldChampionship"
                  style="display:none;"
                  v-model="formData.closure"
                />
                <label class="label-input-radio" for="closure-w">{{
                  formData.closure === "worldChampionship" ? "✔" : ""
                }}</label>
                <div class="com-anm22-app-text-m" style="margin:0 5px;">
                  {{ $anm22.strLang(lang, "World Championship", "Mondiale") }}
                </div>
              </div>
            </div>
          </div>
          <div class="wg-row input-row" style="min-height:36px;">
            <div class="wg-col wg-xs-3">
              <div class="com-anm22-app-text-m">
                {{
                  $anm22.strLang(
                    lang,
                    "Graphic design technique",
                    "Tecnica di realizzazione grafica"
                  )
                }}
              </div>
            </div>
            <div class="wg-col wg-xs-9">
              <div class="wg-row" style="align-items:center;">
                <input
                  v-if="formData.printTreatment == 1"
                  :disabled="mode === 'view'"
                  id="treatment-1"
                  type="radio"
                  value="1"
                  style="display:none;"
                  v-model="formData.printTreatment"
                />
                <label
                  v-if="formData.printTreatment == 1"
                  class="label-input-radio"
                  for="treatment-1"
                  >{{ formData.printTreatment == 1 ? "✔" : "" }}</label
                >
                <div
                  v-if="formData.printTreatment == 1"
                  class="com-anm22-app-text-m"
                  style="margin:0 5px;"
                >
                  {{ $anm22.strLang(lang, "Old flag", "Vecchio flag") }}
                </div>
                <div
                  v-if="formData.printTreatment == 1"
                  class="com-anm22-horizontal-div"
                  style="width: 20px;"
                ></div>
                <input
                  :disabled="mode === 'view'"
                  id="treatment-sewn"
                  type="radio"
                  value="sewn"
                  style="display:none;"
                  v-model="formData.printTreatment"
                />
                <label class="label-input-radio" for="treatment-sewn">{{
                  formData.printTreatment === "lorica" ||
                  formData.printTreatment === "sewn"
                    ? "✔"
                    : ""
                }}</label>
                <div class="com-anm22-app-text-m" style="margin:0 5px;">
                  {{ $anm22.strLang(lang, "Sewn logos", "Loghi cuciti") }}
                </div>
                <div
                  class="com-anm22-horizontal-div"
                  style="width: 20px;"
                ></div>
                <input
                  :disabled="mode === 'view'"
                  id="treatment-print"
                  type="radio"
                  value="directPrint"
                  style="display:none;"
                  v-model="formData.printTreatment"
                />
                <label class="label-input-radio" for="treatment-print">{{
                  formData.printTreatment === "directPrint" ||
                  formData.printTreatment === "transfer" ||
                  formData.printTreatment === "uv"
                    ? "✔"
                    : ""
                }}</label>
                <div class="com-anm22-app-text-m" style="margin:0 5px;">
                  {{
                    $anm22.strLang(
                      lang,
                      "Direct print logos",
                      "Loghi stampa diretta"
                    )
                  }}
                </div>
                <div
                  class="com-anm22-horizontal-div"
                  style="width: 20px;"
                ></div>
                <input
                  :disabled="mode === 'view'"
                  id="treatment-custom"
                  type="radio"
                  value="fullCustom"
                  style="display:none;"
                  v-model="formData.printTreatment"
                />
                <label class="label-input-radio" for="treatment-custom">{{
                  formData.printTreatment === "fullCustom" ? "✔" : ""
                }}</label>
                <div class="com-anm22-app-text-m" style="margin:0 5px;">
                  {{ $anm22.strLang(lang, "Full custom", "Full custom") }}
                </div>
                <template v-if="formData.printTreatment === 'fullCustom'">
                  <div class="vertical-height-div" style="height:10px;"></div>
                  <div class="wg-col wg-xs-12 wg-sm-6">
                    <textarea
                      :disabled="mode === 'view'"
                      class="input-elem com-anm22-app-textarea print-note model-row"
                      style="height:100px;width:100%;max-width:unset;"
                      v-model.lazy="formData.printTreatmentCustom"
                    ></textarea></div
                ></template>
              </div>
            </div>
          </div>
          <div class="wg-row input-row" style="height:36px;">
            <div class="wg-col wg-xs-3">
              <div class="com-anm22-app-text-m">
                {{ $anm22.strLang(lang, "Perforations", "Traforatura") }}
              </div>
            </div>
            <div class="wg-col wg-xs-9">
              <div class="wg-row" style="align-items:center;">
                <input
                  :disabled="mode === 'view'"
                  id="perf-y"
                  type="radio"
                  value="y"
                  style="display:none;"
                  v-model="formData.perforations"
                />
                <label class="label-input-radio" for="perf-y">{{
                  formData.perforations === "y" ||
                  formData.perforations === "medium" ||
                  formData.perforations === "total" ||
                  formData.perforations === "beforePrint" ||
                  formData.perforations === "afterPrint"
                    ? "✔"
                    : ""
                }}</label>
                <div class="com-anm22-app-text-m" style="margin:0 5px;">
                  {{ $anm22.strLang(lang, "Yes", "Si") }}
                </div>
                <div
                  class="com-anm22-horizontal-div"
                  style="width: 20px;"
                ></div>
                <input
                  :disabled="mode === 'view'"
                  id="perf-no"
                  type="radio"
                  value="no"
                  style="display:none;"
                  v-model="formData.perforations"
                />
                <label class="label-input-radio" for="perf-no">{{
                  formData.perforations === "no" ? "✔" : ""
                }}</label>
                <div class="com-anm22-app-text-m" style="margin:0 5px;">
                  {{ $anm22.strLang(lang, "No", "No") }}
                </div>
              </div>
            </div>
          </div>
        </template>
      </template>
      <div class="wg-row input-row" style="height:36px;">
        <div class="com-anm22-app-text-m">
          {{ $anm22.strLang(lang, "Colors", "Colori") }}
        </div>
      </div>
      <div class="wg-row input-row" style="flex-wrap: wrap;">
        <div
          v-for="colorIndex in 8"
          :key="colorIndex"
          class="wg-col wg-xs-12 wg-sm-6"
        >
          <div class="wg-row input-row">
            <div class="com-anm22-app-text-m">{{ colorIndex }}</div>
            <select
              v-if="mode == 'edit'"
              class="input-elem com-anm22-app-select"
              v-model="formData['draftColor' + colorIndex]"
            >
              <option value>Nessun Colore</option>
              <option
                v-for="(color, index) in selectColorList()"
                :key="'color' + colorIndex + '-' + index"
                :value="color.idWarehouseProduct"
                >{{ color.name }}</option
              >
            </select>
            <input
              disabled
              type="text"
              class="input-elem com-anm22-app-input-text"
              v-else
              :value="
                formData['draftColor' + colorIndex] == ''
                  ? 'Nessun Colore'
                  : getColorName(colors[colorIndex])
              "
            />
          </div>
        </div>
      </div>
      <div class="wg-row" v-if="mode === 'prod'">
        <input
          type="button"
          :value="$anm22.strLang(lang, 'Save', 'Salva')"
          @click="saveForm"
        />
        <div class="vertical-height-div" style="height:10px;"></div>
      </div>
      <!-- NOTE -->
      <div class="wg-row input-row" v-if="mode != 'prod'">
        <div class="wg-col wg-xs-12 wg-sm-6">
          <div class="com-anm22-app-text-m">
            {{ $anm22.strLang(lang, "Notes", "Note") }}
          </div>
        </div>
        <div class="vertical-height-div wg-sm-none" style="height:10px;"></div>
        <div class="wg-col wg-xs-12 wg-sm-6">
          <textarea
            :disabled="mode === 'view'"
            class="input-elem com-anm22-app-textarea print-note model-row"
            style="height:100px;width:100%;max-width:unset;"
            v-model.lazy="formData.notes"
          ></textarea>
        </div>
      </div>
      <div class="wg-row input-row" v-if="mode != 'prod'">
        <div class="wg-col wg-xs-12 wg-sm-6">
          <div class="com-anm22-app-text-m">
            {{ $anm22.strLang(lang, "Last edit", "Ultima modifica") }}
          </div>
        </div>
        <div class="vertical-height-div wg-sm-none" style="height:10px;"></div>
        <div class="wg-col wg-xs-12 wg-sm-6">
          <div class="com-anm22-app-text-m">
            {{ lastEditDate + " " + lastEditUser }}
          </div>
        </div>
      </div>
      <template v-if="mode === 'edit' || mode === 'prod'">
        <div class="vertical-height-div" style="height:10px;"></div>
        <div class="wg-row">
          <div class="com-anm22-app-text-xl">
            {{ $anm22.strLang(lang, "Attachment", "Allegato") }}
          </div>
        </div>
        <div class="vertical-height-div" style="height:10px;"></div>
        <div class="wg-row">
          <template v-if="draftGraphicImages">
            <div
              v-for="(img, index) in draftGraphicImages.filter((i) => i)"
              :key="'img-' + index"
              style="position:relative;height:100px;width:100px;margin:5px;cursor:pointer;"
            >
              <img
                style="height:100%;width:100%;"
                :src="$anm22.getImagePath(img)"
                @click="showPic(img)"
              />
              <img
                v-if="mode === 'edit'"
                class="com-anm22-app-img-fixed-height-m"
                style="position:absolute;top:3px;right:3px;"
                :src="$anm22.icons.getWorldIcon('deleteBin')"
                @click="removeImage(index)"
              />
            </div>
          </template>
          <anm22-file-uploader
            v-if="mode === 'edit'"
            :uploadUrl="
              'vircos/draft-graphics-image?idWorldProject=' + imagesProjectId
            "
            :onSuccess="addImage"
          ></anm22-file-uploader>
        </div>
        <div class="vertical-height-div" style="height:10px;"></div>
        <div class="wg-row" v-if="mode === 'edit'">
          <input
            type="button"
            :value="$anm22.strLang(lang, 'Save', 'Salva')"
            @click="saveForm"
          />
          <input
            type="button"
            style="margin-left:10px;"
            :value="
              $anm22.strLang(lang, 'Download template', 'Scarica template')
            "
            @click="downloadTemplate"
          />
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Anm22FileUploader from "../../../../../../world/spa/components/Anm22FileUploaderInline.vue";
import PictureDrawer from "./PictureDrawer.vue";
import PictureViewer from "./PictureViewer.vue";

export default {
  props: {
    projectId: [Number, String],
    docs: Object,
    sizes: Array,
    mainProjectDocs: {
      type: Object | null,
      default: null,
    },
    mode: {
      type: String,
      default: "edit",
    },
  },
  data() {
    return {
      formData: {},
      sheetData: {},
      colorList: [
        { idWarehouseProduct: 134, name: "Bovina Nero Asfalto 09" },
        { idWarehouseProduct: 135, name: "Bovina Grigio Grafite 10" },
        { idWarehouseProduct: 136, name: "Bovina Silver Alluminio 11" },
        { idWarehouseProduct: 137, name: "Bovina Cromato 87" },
        { idWarehouseProduct: 138, name: "Bovina Bianco Ghiaccio 04" },
        { idWarehouseProduct: 139, name: "Bovina Oro 17" },
        { idWarehouseProduct: 140, name: "Bovina Verde Bandiera 22" },
        { idWarehouseProduct: 141, name: "Bovina Verde Fluorescente 24" },
        { idWarehouseProduct: 142, name: "Bovina Azzurro Jerez 01" },
        { idWarehouseProduct: 143, name: "Bovina Blu Metallizzato 02" },
        { idWarehouseProduct: 144, name: "Bovina Blu Scozia 03" },
        { idWarehouseProduct: 145, name: "Bovina Giallo Fluorescente 05" },
        { idWarehouseProduct: 146, name: "Bovina Giallo Corse 14" },
        { idWarehouseProduct: 147, name: "Bovina Arancione Fluorescente 06" },
        { idWarehouseProduct: 148, name: "Bovina Rosso Fluorescente 17" },
        { idWarehouseProduct: 149, name: "Canguro Nero Asfalto 50" },
        { idWarehouseProduct: 150, name: "Canguro Grigio Grafite 51" },
        { idWarehouseProduct: 151, name: "Canguro Silver Alluminio 52" },
        { idWarehouseProduct: 152, name: "Canguro Bianco Ghiaccio 53" },
        { idWarehouseProduct: 153, name: "Canguro Blu Competizione 81" },
        { idWarehouseProduct: 154, name: "Canguro Blu Metallizzato 55" },
        { idWarehouseProduct: 155, name: "Canguro Blu Scozia 54" },
        { idWarehouseProduct: 156, name: "Canguro Blu Riflettente 77" },
        { idWarehouseProduct: 157, name: "Canguro Azzurro Jerez 64" },
        { idWarehouseProduct: 158, name: "Canguro Azzurro Leopard 76" },
        { idWarehouseProduct: 159, name: "Canguro Verde Naturale 66" },
        { idWarehouseProduct: 160, name: "Canguro Verde Fluorescente 58" },
        { idWarehouseProduct: 161, name: "Canguro verde petrolio 82" },
        { idWarehouseProduct: 162, name: "Canguro Ottanio 83" },
        { idWarehouseProduct: 163, name: "Canguro Rosso Misano 70" },
        { idWarehouseProduct: 164, name: "Canguro Rosso Factory 19" },
        { idWarehouseProduct: 165, name: "Canguro Rosso Fluorescente 60" },
        { idWarehouseProduct: 166, name: "Canguro Rosso Scuderia 80" },
        { idWarehouseProduct: 167, name: "Canguro Fucsia 85" },
        { idWarehouseProduct: 168, name: "Canguro Bordeaux 84" },
        { idWarehouseProduct: 169, name: "Canguro Giallo Fluorescente 59" },
        { idWarehouseProduct: 170, name: "Canguro Giallo Corse 56" },
        { idWarehouseProduct: 171, name: "Canguro Arancione Fluorescente 61" },
        { idWarehouseProduct: 172, name: "Canguro Arancione Spielberg 86" },
        { idWarehouseProduct: 173, name: "Canguro Azzurro Gresini" },
        { idWarehouseProduct: 174, name: "Canguro Blu Sasaki" },
        { idWarehouseProduct: 175, name: "Racing Nero Asfalto 50" },
        { idWarehouseProduct: 176, name: "Racing Grigio Grafite 51" },
        { idWarehouseProduct: 177, name: "Racing Silver Alluminio 52" },
        { idWarehouseProduct: 178, name: "Racing Bianco Ghiaccio 53" },
        { idWarehouseProduct: 179, name: "Racing Blu Competizione 81" },
        { idWarehouseProduct: 180, name: "Racing Blu Metallizzato 55" },
        { idWarehouseProduct: 181, name: "Racing Blu Scozia 54" },
        { idWarehouseProduct: 182, name: "Racing Blu Riflettente 77" },
        { idWarehouseProduct: 183, name: "Racing Azzurro Jerez 64" },
        { idWarehouseProduct: 184, name: "Racing Azzurro Leopard 76" },
        { idWarehouseProduct: 185, name: "Racing Verde Naturale 66" },
        { idWarehouseProduct: 186, name: "Racing Verde Fluorescente 58" },
        { idWarehouseProduct: 187, name: "Racing verde petrolio 82" },
        { idWarehouseProduct: 188, name: "Racing Ottanio 83" },
        { idWarehouseProduct: 189, name: "Racing Rosso Misano 70" },
        { idWarehouseProduct: 190, name: "Racing Rosso Factory 19" },
        { idWarehouseProduct: 191, name: "Racing Rosso Fluorescente 60" },
        { idWarehouseProduct: 192, name: "Racing Rosso Scuderia 80" },
        { idWarehouseProduct: 193, name: "Racing Fucsia 85" },
        { idWarehouseProduct: 194, name: "Racing Bordeaux 84" },
        { idWarehouseProduct: 195, name: "Racing Giallo Fluorescente 59" },
        { idWarehouseProduct: 196, name: "Racing Giallo Corse 56" },
        { idWarehouseProduct: 197, name: "Racing Arancione Fluorescente 61" },
        { idWarehouseProduct: 198, name: "Racing Arancione Spielberg 86" },
        { idWarehouseProduct: 199, name: "Racing Azzurro Gresini" },
        { idWarehouseProduct: 200, name: "Racing Blu Sasaki" },
        { idWarehouseProduct: 201, name: "Crosta" },
        { idWarehouseProduct: 202, name: "Rinforzo Crostina" },
      ],
      tabToShow: "default",
      picToShow: null,
      showDrawer: false,
      notificationSended: false,
    };
  },
  computed: {
    ...mapState({
      lang: (state) => state.lang,
      user: (state) => state.auth.user,
    }),
    project() {
      return this.$store.getters["projects/get"]([this.projectId]);
    },
    useMainProjectImages() {
      if (this.docs && this.docs.data && this.docs.data.mainProjectId) {
        return true;
      } else {
        return false;
      }
    },
    draftGraphicImages() {
      if (this.useMainProjectImages) {
        if (
          this.mainProjectDocs &&
          this.mainProjectDocs.graphics &&
          this.mainProjectDocs.graphics.draftImages
        ) {
          return this.mainProjectDocs.graphics.draftImages;
        }
        return [];
      } else {
        return this.formData.draftImages;
      }
    },
    imagesProjectId() {
      if (this.useMainProjectImages) {
        return this.docs.data.mainProjectId;
      } else {
        return this.project.idWorldProject;
      }
    },
    lastEditUser() {
      const user = this.$store.getters["users/get"](this.formData.lastUser);
      return user ? user.name + " " + user.surname : "";
    },
    lastEditDate() {
      return this.formData.lastUpdate
        ? this.$moment.unix(this.formData.lastUpdate).format("DD/MM/YYYY HH:mm")
        : "";
    },
    modelsList() {
      return this.sizes
        .filter((item) => !item.size)
        .sort((a, b) => a.modelName.localeCompare(b.modelName));
    },
  },
  methods: {
    saveForm(notCloseModal) {
      const docs = { ...this.docs };
      docs.graphics = this.formData;
      docs.graphics.lastUser = this.user.idWorldUser;
      docs.graphics.lastUpdate = this.$moment().unix();
      docs.measuresSheet = this.sheetData;
      this.$emit("save", docs);
      if (this.mode !== "prod" && notCloseModal !== true) {
        this.$anm22.eventBus.$emit("wg-modal-close");
      }
    },
    showPic(img) {
      this.picToShow = img;
      this.showDrawer = false;
      this.tabToShow = "pic";
    },
    closePic() {
      this.tabToShow = "default";
      this.picToShow = null;
    },
    addImage(data) {
      if (this.useMainProjectImages) {
        this.addImageToMainProject(data);
      } else {
        this.addImageToCurrentProject(data);
      }
    },
    addImageToMainProject(data) {
      const mainDocs = { ...this.mainProjectDocs };
      if (!mainDocs.graphics.draftImages) {
        mainDocs.graphics.draftImages = [];
      }
      mainDocs.graphics.draftImages.push(data.url);
      mainDocs.graphics.lastUser = this.user.idWorldUser;
      mainDocs.graphics.lastUpdate = this.$moment().unix();
      this.$http
        .post(
          "vircos",
          {
            projectId: this.imagesProjectId,
            docs: mainDocs,
          },
          {
            withCredentials: true,
          }
        )
        .then((response) => {
          this.$vlf("vircos-project-docs").setItem(
            String(response.data.docs.project),
            response.data.docs
          );
          this.formData.draftImages = response.data.docs.graphics.draftImages;
          this.saveForm(true);
        })
        .catch((error) => {
          /* offline */
        });
    },
    addImageToCurrentProject(data) {
      if (!this.formData.draftImages) {
        this.formData.draftImages = [];
      }
      this.formData.draftImages.push(data.url);
      const docs = { ...this.docs };
      docs.graphics = this.formData;
      docs.graphics.lastUser = this.user.idWorldUser;
      docs.graphics.lastUpdate = this.$moment().unix();
      this.$http
        .post(
          "vircos",
          {
            projectId: this.project.idWorldProject,
            docs: docs,
          },
          {
            withCredentials: true,
          }
        )
        .then((response) => {
          this.$vlf("vircos-project-docs").setItem(
            String(response.data.docs.project),
            response.data.docs
          );
          this.formData = response.data.docs.graphics;
        })
        .catch((error) => {
          /* offline */
        });
    },
    removeImage(index) {
      if (this.useMainProjectImages) {
        const docs = { ...this.mainProjectDocs };
        docs.graphics.draftImages.splice(index, 1);
        docs.graphics.lastUser = this.user.idWorldUser;
        docs.graphics.lastUpdate = this.$moment().unix();
        this.$http
          .post(
            "vircos",
            {
              projectId: this.imagesProjectId,
              docs: docs,
            },
            {
              withCredentials: true,
            }
          )
          .then((response) => {
            this.$vlf("vircos-project-docs").setItem(
              String(response.data.docs.project),
              response.data.docs
            );
          })
          .catch((error) => {
            /* offline */
          });
      } else {
        this.formData.draftImages.splice(index, 1);
        const docs = { ...this.docs };
        docs.graphics = this.formData;
        docs.graphics.lastUser = this.user.idWorldUser;
        docs.graphics.lastUpdate = this.$moment().unix();
        this.$http
          .post(
            "vircos",
            {
              projectId: this.project.idWorldProject,
              docs: docs,
            },
            {
              withCredentials: true,
            }
          )
          .then((response) => {
            this.$vlf("vircos-project-docs").setItem(
              String(response.data.docs.project),
              response.data.docs
            );
            this.formData = response.data.docs.graphics;
          })
          .catch((error) => {
            /* offline */
          });
      }
    },
    downloadTemplate() {
      this.$http
        .get("https://www.anm22.it/app/tasks/vircos/template-grafiche.pdf", {
          responseType: "blob", // important
        })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "file.pdf"); //or any other extension
          document.body.appendChild(link);
          link.click();
        });
    },
    selectColorList() {
      let colorList = this.colorList;
      return colorList;
    },
    findProductIdByLeatherName(leatherName) {
      for (let i = 0; i < this.colorList.length; i++) {
        if (this.colorList[i].name === leatherName) {
          return this.colorList[i].idWarehouseProduct;
        }
      }
      // Ritorna null se il nome non è stato trovato
      return leatherName;
    },
    getColorName(productId) {
      for (let i = 0; i < this.colorList.length; i++) {
        if (this.colorList[i].idWarehouseProduct === productId) {
          return this.colorList[i].name;
        }
      }
      // Ritorna null se il nome non è stato trovato
      return productId;
    },
  },
  created() {
    this.formData = { ...this.docs.graphics };
    if (this.formData.notes && Array.isArray(this.formData.notes)) {
      if (this.formData.notes.length > 0) {
        this.formData.notes = this.formData.notes[
          this.formData.notes.length - 1
        ].note;
      } else {
        this.formData.notes = "";
      }
    }
    this.sheetData = { ...this.docs.measuresSheet };

    // Size retro
    if (this.sheetData.sizeSelected && !this.sheetData.modelName && !this.sheetData.sizeTop && !this.sheetData.sizeBottom) {
      const oldModelBases = this.sizes.filter(
        (item) => item.idVircosModelsBase == this.sheetData.sizeSelected
      );
      if (oldModelBases.length > 0) {
        const oldModelBase = oldModelBases[0];
        this.sheetData.modelName = oldModelBase.modelName;
        this.sheetData.sizeTop = oldModelBase.size;
        this.sheetData.sizeBottom = oldModelBase.size;
      }
    }
  },
  components: {
    Anm22FileUploader,
    PictureViewer,
    PictureDrawer,
  },
};
</script>

<style lang="scss" scoped>
.input-row {
  flex-wrap: nowrap;
  align-items: center;
  justify-content: space-between;
  padding: 0 5px;
  margin-bottom: 10px;
}
.input-elem {
  width: 100%;
  max-width: 200px;
}
.label-input-radio {
  display: block;
  height: 20px;
  width: 20px;
  border: 1px solid #bbb;
  border-radius: 4px;
  font-size: 16px;
  padding: 1px 2px;
  cursor: pointer;
}
.pic-viewer {
  height: calc(90vh - 91px);
  width: 100%;
  justify-content: center;
  position: relative;
}
.vircos-notification-send-btn {
  cursor: pointer;
  position: relative;
  padding: 6px 12px 6px 32px;
  background-color: #eee;
  color: #000;
  border-radius: 6px;
  font-size: 14px;
  display: inline-block;

  &:hover {
    background-color: #ddd;
  }

  img {
    position: absolute;
    left: 10px;
    top: 6px;
    width: 16px;
  }
}
.vircos-notification-sended {
  position: relative;
  padding: 6px 12px 6px 22px;
  color: #000;
  border-radius: 6px;
  font-size: 14px;
  display: inline-block;

  img {
    position: absolute;
    left: 0px;
    top: 6px;
    width: 16px;
  }
}
.edit-pic {
  position: absolute;
  top: 7px;
  right: 45px;
  width: 25px;
  height: 25px;
  cursor: pointer;
}
.close-pic {
  position: absolute;
  top: 10px;
  right: 10px;
  width: 20px;
  height: 20px;
  z-index: 10;
  cursor: pointer;
}
@media print {
  .model-row {
    width: 541px !important;
    max-width: 541px !important;
  }
  .print-note {
    height: 541px !important;
  }

  .no-print {
    display: none;
  }
}
</style>
